// /features/blueprint/viewmodels/BlueprintNavigationViewModel.ts

import { Answers } from "@/features/blueprint/schema/answers/Answers";
import { QuestionSchema } from "@/features/blueprint/schema/questions/QuestionSchema";


export function buildNavSections(t: (key: string) => string, sections: QuestionSchema[]): QuestionSchema[] {
    return [
        ...sections,
        {
            id: "__summary",
            title: t("ui.summary_section"),
            questions: [],
        },
    ];
}

export function calculateCompletedSectionIndices(
    sections: QuestionSchema[],
    answers: Answers
): number[] {
    const completed = sections
        .map((section, idx) =>
            areAllQuestionsAnswered(section.questions, answers) ? idx : -1
        )
        .filter((idx) => idx >= 0);

    if (completed.length === sections.length) {
        completed.push(sections.length); // summary step
    }

    return completed;
}

export function areAllQuestionsAnswered(
    questions: QuestionSchema["questions"],
    answers: Answers
): boolean {
    return questions.every((q) => isAnswerValid(answers[q.id]));
}

export function isAnswerValid(value: unknown): boolean {
    if (typeof value === "string") return value.trim() !== "";
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === "boolean") return value === true;
    return false;
}

export function checkIsSummaryStep(currentIndex: number, sections: QuestionSchema[]): boolean {
    return currentIndex === sections.length;
}

export function getActiveSection(
    sections: QuestionSchema[],
    currentIndex: number
): QuestionSchema {
    return sections[currentIndex];
}
